import https from 'https';

export const getDefaultAxiosConfig = () => ({
    headers: {
        Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`
    },
    httpsAgent: new https.Agent({
        rejectUnauthorized: false,
    }),
}); 